import axios, { AxiosResponse } from 'axios';

export const defaultCustomerDetails: CustomerDemographicDetails = {
	customerId: undefined,
	hasSpouse: undefined,
	mortgage: undefined,
	otherDebt: undefined,
	beneficiaryAmountPerYear: undefined,
	beneficiaryAmountTotalYears: undefined,
	savingsAmount: undefined,
	isSmoker: undefined,
	lastSmokedDate: '',
	age: undefined,
};

export const defaultCustomerFamily: CustomerFamily = {
	familyMemberId: undefined,
	name: '',
	age: undefined,
	relationship: '52866e41fdfae711b9c80028f80bded3' // Child. Using the FamilyRelationship enum in utils doesn't work.
};

const apiUrl = process.env.REACT_APP_API_URL;
const quotingAPI = {
	fetchHeightWeightTable: () => {
		return axios.get(`${apiUrl}/height-weight-table.json`)
			.then((resp: AxiosResponse) => resp.data);
	},
	fetchCustomerDetails: (customerId: string) => {
		return axios.get(`${apiUrl}/customers/${customerId}/details.json`)
			.then((resp: AxiosResponse) => resp.data);
	},
	fetchCustomerFamilyList: (customerId: string) => {
		return axios.get(`${apiUrl}/customers/${customerId}/familylist.json`)
			.then((resp: AxiosResponse) => resp.data);
	},
	saveCustomerDetails: (customerDetails: CustomerDemographicDetails) => {
		return axios.post(`${apiUrl}/customers/details`, customerDetails)
			.then((resp: AxiosResponse) => resp.data);
	},
	saveCustomerFamilyList: (customerId: string, customerFamilyList: CustomerFamily[]) => {
		const data = {
			customerId,
			customerFamilyList
		};
		return axios.post(`${apiUrl}/customers/familyList`, data)
			.then((resp: AxiosResponse) => resp.data);
	},
	validateReferralCode: (referralCode: string, userId: number) => {
		const data = { referralCode, userId };
		return axios.post(`${apiUrl}/referral`, data)
			.then((resp: AxiosResponse) => resp.data as boolean);
	},
};

export default quotingAPI;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/quotingAPI.ts